import { all, takeEvery, takeLatest } from 'redux-saga/effects'

import { ThreadsActions } from '../actions'
import { create } from './create'
import { deleteThread } from './delete'
import { edit } from './edit'
import { list } from './list'
import { move } from './move'
import { reopen } from './reopen'
import { resolve } from './resolve'

export function* threadsSaga() {
  yield all([
    takeEvery(ThreadsActions.edit, edit),
    takeEvery(ThreadsActions.resolve, resolve),
    takeEvery(ThreadsActions.reopen, reopen),
    takeEvery(ThreadsActions.create, create),
    takeEvery(ThreadsActions.move, move),
    takeEvery(ThreadsActions.delete, deleteThread),
    // Список грузится вместе с проектом; при смене проекта актуален только
    // последний запрос — иначе поздний ответ по старому проекту затрёт треды
    takeLatest(ThreadsActions.list, list),
  ])
}
